import React, { useState, useEffect } from "react";
import { supabase } from "../supabase";
import EditTVModal from "./EditTVModal";

function TVList({ userId }) {
  const [selectedTV, setSelectedTV] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tvs, setTvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTVs = async () => {
      try {
        const { data, error } = await supabase
          .from("tv_devices")
          .select(
            `
            *,
            tv_groups (
              name
            )
          `
          )
          .eq("created_by", userId)
          .order("created_at", { ascending: false });

        if (error) throw error;
        setTvs(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTVs();

    // Subscribe to changes
    const channel = supabase
      .channel("tv_devices_changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tv_devices",
          filter: `created_by=eq.${userId}`,
        },
        fetchTVs
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!tvs.length)
    return <div>No TVs found. Scan a TV's QR code to adopt it.</div>;

  return (
    <>
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {tvs.map((tv) => (
          <div key={tv.id} className="border rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold">{tv.name}</h3>
            <p className="text-sm text-gray-600">ID: {tv.device_id}</p>
            <p className="text-sm text-gray-600">
              Group: {tv.tv_groups?.name || "None"}
            </p>
            <p className="text-sm text-gray-600">
              Status: {tv.is_active ? "Active" : "Inactive"}
            </p>
            <div className="flex gap-2 mt-2">
              <button
                onClick={() => {
                  setSelectedTV(tv);
                  setIsModalOpen(true);
                }}
                className="text-sm text-indigo-600 hover:text-indigo-900"
              >
                Edit
              </button>
            </div>
          </div>
        ))}
      </div>
      {selectedTV && (
        <EditTVModal
          tv={selectedTV}
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedTV(null);
          }}
          onSave={() => {
            setIsModalOpen(false);
            setSelectedTV(null);
          }}
        />
      )}
    </>
  );
}

export default TVList;
